/**
 * horseArchiveService.js — Archivage d'un cheval (S3)
 */
import { authFetch, getAuthHeaders } from '../utils/authFetch';

/** Absent ou null = non archivé (aucune migration des chevaux existants). */
export const isArchived = (horse) => Boolean(horse?.archivedAt);

/**
 * Chevaux proposés à l'import CSV : les chevaux possédés archivés sont exclus ;
 * les chevaux partagés restent proposés tels quels (en V1, l'archivage du
 * propriétaire ne change rien pour la personne de confiance ou le vétérinaire).
 */
export const selectUploadHorses = (owned = [], shared = []) => [...owned.filter(h => !isArchived(h)), ...shared];

/**
 * PATCH /api/horses/:id/archive | /unarchive
 * @returns {Promise<{ ok: true, horse: Object } | { ok: false, forbidden: boolean }>}
 */
export async function requestHorseArchive(horseId, archived) {
  try {
    const res = await authFetch(`/api/horses/${horseId}/${archived ? 'archive' : 'unarchive'}`, {
      method: 'PATCH',
      credentials: 'include',
      headers: getAuthHeaders(),
    });
    const data = await res.json();
    if (res.ok && data.success) return { ok: true, horse: data.horse };
    return { ok: false, forbidden: data.error === 'ARCHIVE_OWNER_ONLY' };
  } catch (err) {
    console.error('requestHorseArchive:', err);
    return { ok: false, forbidden: false };
  }
}
